import {Route,Routes} from "react-router-dom";

import './App.css';

import Landing from './pages/landing';
import VehiculosComponent from "./pages/vehiculos";
import UsuariosComponent from "./pages/usuarios";
import FotoComponent from "./pages/ingreso/foto";
import ConfirmarDatos from "./pages/ingreso/confirmarDatos";
import IngresoPolicialComponent from "./pages/ingreso/ingresoPolicial";
import LeerQRComponent from "./pages/vehiculos/leerQR/leerQR";
import NuevoUsuarioComponent from "./pages/usuarios/nuevoUsuario/nuevoUsuario";
import IngresoDetallesComponent from "./pages/ingreso/ingresoDetalles";
import ResetearUsuarioComponent from "./pages/usuarios/configurarUsuario/resetearUsuario";
import ProtectedRoute from "./components/protectedRoute/protectedRoute";
import LicenciasComponent from "./pages/licencias";
import RegistrosComponent from "./pages/vehiculos/registros";
import OpcionesFotoComponent from "./pages/ingreso/opcionesFoto";
import SubirFotoComponent from "./pages/ingreso/subirFoto";
import TakeFotoToDetailComponent from "./pages/detail/takeFotoToDetail";
import ACompactarComponent from "./pages/vehiculos/compactar/aCompactar/aCompactarTable";
import LevantamientosComponent from "./pages/vehiculos/levantamientos/levantamientos";
import CompactacionComponent from "./pages/vehiculos/compactar";
import StockActualComponent from "./pages/vehiculos/stockActual/stockActual";
import CambiarSectorComponent from "./pages/detail/modals/cambiarSector";
import DetailComponent from "./pages/detail";
import Home from "./pages/home";
import IngresoComponent from "./pages/ingreso";
import BuscarVehiculoComponent from "./pages/vehiculos/buscarVehiculo/buscarVehiculo";


function App() {
  return (
    <div>
      <Routes>
        <Route path='/salir' element={<Landing/>}/>
        <Route path='/' element={<Landing/>}/>
         {/* Rutas protegidas */}
         <Route
          path='/*'
          element={
            <ProtectedRoute>
              <Routes>
                <Route path='/inicio' element={<Home />} />
                <Route path='/detail/:id' element={<DetailComponent />} />
                <Route path='/take_foto_detail' element={<TakeFotoToDetailComponent />} />
                <Route path='/ingreso' element={<IngresoComponent />} />
                <Route path='/ingreso_policial' element={<IngresoPolicialComponent />} />
                <Route path='/ingreso_detalles' element={<IngresoDetallesComponent />} />
                <Route path='/opciones_ingreso_foto' element={<OpcionesFotoComponent />} />
                <Route path='/ingreso_foto' element={<FotoComponent />} />
                <Route path='/subir_foto' element={<SubirFotoComponent />} />
                <Route path='/ingreso_confirmacion' element={<ConfirmarDatos />} />
                <Route path='/vehiculos' element={<VehiculosComponent />} />
                <Route path='/licencias' element={<LicenciasComponent />} />
                <Route path='/leerQR' element={<LeerQRComponent />} />
                <Route path='/buscar' element={<BuscarVehiculoComponent />} />
                <Route path='/registros' element={<RegistrosComponent />} />
                <Route path='/levantamientos' element={<LevantamientosComponent />} />
                <Route path='/compactacion' element={<CompactacionComponent />} />
                <Route path='/a_compactar' element={<ACompactarComponent />} />
                <Route path='/stock_actual' element={<StockActualComponent />} />
                <Route path='/usuarios' element={<UsuariosComponent />} />
                <Route path='/resetear_usuario' element={<ResetearUsuarioComponent />} />
                <Route path='/nuevo_usuario' element={<NuevoUsuarioComponent />} />
                <Route path='/cambiar_sector' element={<CambiarSectorComponent />} />
              </Routes>
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
